import React from 'react';

/**
 * SUIVI DE STAGE — CERTIFICATION, ce que le tableau ET le panneau montrent de la même façon (lot C.1).
 * ⚠️ Un fichier à part : le tableau importe le panneau ; si le panneau importait le tableau, l'import
 * serait circulaire, et une zone morte temporelle passe la compilation pour casser à l'écran.
 */

/** Les cases des livrables (une par livrable, « H » pour hors entreprise) + le résumé. */
export function CasesLivrables({ cases, resume }) {
    const TITRES = { attendu: 'attendu', depose: 'déposé', certifie: 'certifié', non_certifie: 'ne peut pas être certifié', hors: 'déclaré hors entreprise' };
    return (
        <div className="certif-docs">
            {cases.map((c, i) => (
                <div key={i} className={'certif-doc ' + c.etat.replace('_', '-')}
                     title={`${c.libelle} — ${TITRES[c.etat] || c.etat}${c.motif ? ' : ' + c.motif : ''}`}>
                    {c.etat === 'hors' ? 'H' : i + 1}
                </div>
            ))}
            {resume && <span className="certif-docs-n">{resume}</span>}
        </div>
    );
}

/**
 * L'action UNIQUE de la ligne (armée au lot C.4a). `onAction(code)` : « completer » ouvre l'endroit où
 * compléter le contact (CB3) ; les autres ouvrent la FENÊTRE D'ENVOI, où l'assistante relit et modifie
 * le message avant de l'envoyer (Bertrand).
 */
export function ActionLigne({ action, statut, modifiable, onAction }) {
    if (statut === 'termine') return <span className="certif-fini"><i className="fa-solid fa-lock" /> Terminé</span>;
    if (!action) return <span style={{ color: '#94a3b8', fontSize: 11 }}>—</span>;
    const titre = !modifiable ? 'Lecture seule : votre profil ne permet pas de modifier ce module.'
        : action.code === 'completer' ? 'Ouvrir l\'endroit où compléter le contact du maître'
        : 'Ouvre la fenêtre d\'envoi : vous relisez et modifiez le message avant de l\'envoyer';
    return (
        <button type="button" className={'certif-action' + (action.classe ? ' ' + action.classe : '')}
                disabled={!modifiable} title={titre}
                onClick={(e) => { e.stopPropagation(); if (modifiable) onAction(action.code); }}>
            <i className={'fa-solid ' + action.icone} /> {action.libelle}
        </button>
    );
}
